import Profile from "../sections/Profile";

function Home() {
    return (
        <div className="Home">
            <Profile />
        </div>
    );
}

export default Home;
